import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '欲火视频需要付费吗？',
    answer: '欲火视频提供大量免费影视资源供用户在线观看。部分最新院线大片和独家内容可能需要会员订阅，但平台每天都会更新大量免费内容，确保所有用户都能享受优质的观影体验。',
  },
  {
    question: '欲火视频支持哪些设备观看？',
    answer: '欲火视频支持多终端流畅播放，包括电脑网页版、手机浏览器、平板设备等。您只需打开浏览器访问欲火视频，无需下载任何软件即可开始观看，真正做到随时随地畅享影视内容。',
  },
  {
    question: '欲火视频的内容更新频率如何？',
    answer: '欲火视频每日更新最新影视内容，包括热门剧集同步更新、新上映电影第一时间上线、综艺节目及时跟进等。我们的内容团队全天候工作，确保您不会错过任何精彩内容。',
  },
  {
    question: '如何搜索我想看的影片？',
    answer: '您可以在欲火视频顶部的搜索框中输入影片名称、演员或导演等关键词进行搜索。此外，您也可以通过分类浏览功能，按电影、电视剧、动漫、综艺等类别查找感兴趣的内容。',
  },
  {
    question: '欲火视频的画质如何？',
    answer: '欲火视频提供高清甚至超高清画质的影视资源，支持自适应码率技术，根据您的网络状况自动调整播放画质，确保流畅的观看体验。所有内容均经过专业转码处理，画质清晰细腻。',
  },
  {
    question: '欲火视频有手机版吗？',
    answer: '欲火视频采用响应式设计，完美适配手机、平板和电脑等多种设备。您只需在手机浏览器中打开欲火视频网站，即可获得专为移动端优化的观看体验，无需额外下载APP。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full py-14 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            关于欲火视频的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                aria-expanded={openIndex === index}
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                  openIndex === index ? 'bg-primary-500 text-white rotate-45' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}